package ru.malygin.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import ru.malygin.myConst.TeacherPlaces

@Serializable
data class FindTeachersItemDto(
//    var id: Int,
//    val category: SelectedCategory = SelectedCategory.TEACHERS,
    @Serializable
    @SerialName("name")
    val name: String,
    @Serializable
    @SerialName("time_request")
    val timeRequest: String,
    @Serializable
    @SerialName("item_dto")
    val itemsDto: List<MainScheduleItemDto>?,
    @Serializable
    @SerialName("places")
    val places: TeacherPlaces
)
